import AOS from 'aos';

export function initAOS() {
	const params  = new URLSearchParams(window.location.search);
	const fromUrl = params.get('animation');

	if (fromUrl === 'off') localStorage.setItem('rb_animation', 'off');
	if (fromUrl === 'on')  localStorage.setItem('rb_animation', 'on');

	const disabled = localStorage.getItem('rb_animation') === 'off';

	if (disabled) {
		document.documentElement.classList.add('aos-disabled');
		return;
	}

	AOS.init({
		duration: 600,
		easing:   'ease-out',
		once:     true,
		offset:   80,
	});
}
